/*
 * @Author: zyy
 * @Date: 2022-03-30 17:56:34
 * @LastEditors: zyy
 * @LastEditTime: 2022-03-31 20:33:11
 * @Description: default
 */
import shopRequests from "./shopRequest";
import Axios from "axios";
import Qs from 'qs'
export default {
    // 商品分类列表
    list(page, limit, name) {
        return Axios.get('/shop/addons/shopro/admin_api_categroy/index', {
            params: {
                page,
                limit,
                name
            },
            paramsSerializer(params) {
                return Qs.stringify(params);
            }
        })
    },
    // 添加分类
    add(name, description, weigh = 0) {
        return Axios.post('/shop/addons/shopro/admin_api_categroy/add', {
            name,
            description,
            weigh
        })
    },
    // 编辑分类
    edit(id, name, description, status = 'normal') {
        shopRequests.post('/shop/addons/shopro/admin_api_categroy/edit', {
            id,
            name,
            status,
            weigh: 0,
            description
        })
    },
    delete(id) {
        return shopRequests.post('/shop/addons/shopro/admin_api_categroy/del', {
            id
        })
    }

}